module.exports = __webpack_public_path__ + "media/images/Sustainability_Dashboard_Icon-6acb1e9c.png";